import _ from 'underscore'
import React from 'react'
import moment from 'moment'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { DropdownMenu } from '../dropdown_menu'
import BacklogItemsPartial from './partial'
import store from '../../state/store'

class BacklogItems extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_priority: false
    }
  }

  onTogglePriority = () => {
    this.setState({
      show_priority: !this.state.show_priority
    })
  }

  onSwitchView = (value) => {
    store.emit('backlog_items:index', {filter: value})
  }

  onManagerChange = (value) => {
    store.emit('backlog_items:index', {manager_id: value})
  }

  onItemClick = (item) => {
    store.emit('backlog_items:select', item)
  }

  managerLabel = (option) => {
    return (option.count != null) ? `${option.name} (${option.count})` : option.name
  }

  renderListItem = (item) => {
    const selected = (this.props.selected_item) ?
      `${item.item_id}` === `${this.props.selected_item.item_id}` && `${item.item_type}` === `${this.props.selected_item.item_type}`
      :
      false

    return (
      <BacklogItemsPartial
        key={item.item_id}
        item={item}
        selected={selected}
        onClick={this.onItemClick}
      />
    )
  }

  render() {
    const backlog = this.props.backlog

    const backlog_state = _.first(
      _.select(backlog.states, (item) => {
        return item.value == backlog.filter
      })
    )

    let groups = _.groupBy(backlog.items, function (item) {
      return moment(item.time).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd, DD MMM YYYY'
      })
    })

    groups = _.pairs(groups)

    const manager = _.first(
      _.select(backlog.manager_options, (item) => {
        return `${item.value}` == `${backlog.manager_id}`
      })
    )

    return (
      <div className="flex h-full min-h-0 flex-col">
        <div className="flex flex-col gap-2 px-4 pt-4 pb-2">
          <div className="flex min-w-0 flex-col gap-1">
            <Label className="text-sm text-muted-foreground">Assigned to</Label>
            {/* Searchable wrapper, not a plain Select — the manager list is
                ~30 people and the legacy dropdown had a search box. */}
            <DropdownMenu
              searchable
              items={backlog.manager_options}
              selected={backlog.manager_id}
              onItemClick={this.onManagerChange}
              buttonClassName="btn-outline btn-sm min-w-0 w-full"
            >
              <span className="min-w-0 truncate">{manager ? this.managerLabel(manager) : ''}</span>
              <ChevronDown className="size-3.5 shrink-0"/>
            </DropdownMenu>
          </div>
          {((backlog.priority_items?.length || 0) > 0) ?
            <Button variant="outline" size="sm" className="w-full" onClick={this.onTogglePriority}>
              Priority ({backlog.priority_items.length}) {this.state.show_priority ? <ChevronDown className="size-3.5" /> : <ChevronUp className="size-3.5" />}
            </Button>
            : null
          }
          <Select value={`${backlog.filter}`} onValueChange={this.onSwitchView}>
            <SelectTrigger size="sm" className="w-full">
              <SelectValue>{(backlog_state || {}).name || ''} ({backlog.items.length || 0})</SelectValue>
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {_.map(backlog.states, (option) => {
                  return (
                    <SelectItem key={`${option.value}`} value={`${option.value}`}>{option.name}</SelectItem>
                  )
                })}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-10">
          {this.state.show_priority ?
            <div className="flex flex-col gap-2 pt-2">
              {_.map(backlog.priority_items, (item) => {
                return this.renderListItem(item)
              })}
            </div>
            : null
          }
          {(backlog.items.length > backlog.limit) &&
            <p className="px-1 pt-3 text-xs text-muted-foreground">
              Your backlog is too large. Only the first 200 items will load. If you don't reduce the size of your backlog, you'll miss out on items.
            </p>
          }
          {_.map(groups, (group) => {
            return (
              <div key={group[0]}>
                <div className="px-1 pt-4 pb-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{group[0]}</div>
                <div className="flex flex-col gap-2">
                  {_.map(group[1], (item) => {
                    return this.renderListItem(item)
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default BacklogItems
